/**
 * @file environment.prod.ts
 * @author Codeforce
 * @date 23 Mar 2020
 * @copyright 2020 BBisnode Deutschland GmbH
 * @brief Prod Environment AWS for Bisnode
 */
export const environment = {
  production: true,
  //apiEndPoint:"https://orc.prod.aws.orange.bisnode.net/amc-forms-orc/v1",
  // apiEndPoint:"http://amc-forms-orc-v1/amc-forms-orc/v1",
  apiEndPoint:"/amc-forms-web",
  //Prod
  httpProtocol:"https://",
  //Dev
  //httpProtocol:"http://",
  apiIpify:"https://api.ipify.org/?format=json",
  newsletterImage: "./assets/images/newsletter_bild.png",
  stickImage: "./assets/images/amc_haken.png",
  amcLogoImage: "./assets/images/amc_logo.png",
  deButton: "./assets/images/debutton.png",
};
